(function(){
'use strict';

angular.module('classy').run(['$templateCache', function ($templateCache) {
  $templateCache.put('global/directives/scMap/scMap', '<div class="sc-map">\n' + '  <div class="form_field-input sc-map_input">\n' + '    <i class="form_input-icon fa fa-globe"></i>\n' + '    <input\n' + '      type="text"\n' + '      name="map"\n' + '      ng-model="model"\n' + '      class="sc-map_autocomplete form_text-input"\n' + '      ng-keydown="keydown($event)"\n' + '      qa-id="{{ bind(\'scQaId.singleLineTextInput\') }}"\n' + '    />\n' + '  </div>\n' + '  <div class="sc-map_map"></div>\n' + '</div>\n' + '');
}]);
})();